import { Pipe, PipeTransform } from '@angular/core';
import { SideMenuService } from 'src/app/services/side-menu.service';

@Pipe({
  name: 'systemLanguages',
  pure: false
})
export class SystemLanguagesPipe implements PipeTransform {
  constructor(
    public menu: SideMenuService
  ) { }
  transform(systemLanguage: any[], moduleId: string, key: string): string {
    let result = '';
    if (systemLanguage) {
      const languageList = this.menu.languageList.getValue();
      const currentLangKey = this.menu.currentLangKey ? this.menu.currentLangKey : (languageList.length ? languageList[0].key : 'bg');
      systemLanguage.filter((sl) => {
        if (sl.key === key) {
          let trans = sl.translations.find((obj) => obj.language === currentLangKey);
          if (typeof trans == "undefined") {
            trans = sl.translations.find((obj) => obj.language === 'bg');
          }
          result = trans ? trans.text : '';
        }
      });
    }

    return result;
  }
}
